import React from 'react';
import styled from 'styled-components';
import NumericInput from 'react-numeric-input';

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 600px;
  height: 100%;
  background: white;
  transition: transform 800ms cubic-bezier(0.32, 0.24, 0.15, 1);
  box-shadow: -4px 0 16px 0 rgba(0,0,0,0.04);
  @media (max-width: 600px) {
    width: 100%;
  }
  z-index: 900;
  ${props => props['data-open'] ? `
    transform: translateX(0);
  ` : `
    transform: translateX(103%);
    transition: transform 500ms cubic-bezier(0.32, 0.24, 0.15, 1);
  `});
`;

const InnerContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-template-rows: auto;
  max-height: calc(100% - 294px);
  overflow: scroll;
  > div:first-child {
    padding-top: 120px;
  }
  > div:nth-last-child(2) {
    border: none;
  }
`;

const Item = styled.div`
  grid-column: 2 / 10;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: auto;
  padding: 20px 0;
  border-bottom: 1px solid #E3E1E0;
  transition: transform 600ms ease calc((${props => props['data-index']} * 100ms) + 400ms), opacity 600ms ease calc((${props => props['data-index']} * 100ms) + 400ms);
  ${props => props['data-open'] ? `
    transform: translateX(0px);
    opacity: 1;
  ` : `
    transform: translateX(50px);
    transition: transform 100ms ease 0ms, opacity 100ms ease 0ms;
    opacity: 0;
  `});
`;

const Image = styled.img`
  grid-column: 1 / 3;
  display: block;
`;

const ItemContent = styled.div`
  grid-column: 3 / 8;
  padding-left: 16px !important;
  .react-numeric-input {
    padding-top: 8px;
    margin-left: -9px;
  }
  b {
    background: white !important;
    border: none !important;
    cursor: pointer !important;
    i {
      background: #52433E !important;
    }
  }
  p {
    margin: 8px 0 0 0;
    color: #52433E;
  }
  h6 {
    margin: 12px 0 3px;
  }
`

const Price = styled.div`
  grid-column: 8 / -1;
  align-items: flex-end;
  display: flex;
  h6 {
    margin: 0 0 7px;
  }
`

const CloseButton = styled.figcaption`
  position: absolute;
  top: 27px;
  right: 48px;
  cursor: pointer;
  color: #938985;
`;

const MobileCloseButton = styled.div`
  position: absolute;
  top: 27px;
  left: 48px;
  cursor: pointer;
  display: none;
  @media (max-width: 600px) {
    display: block;
  }
`;

const Count = styled.span`
  color: #C67732;
`;

const NotesLabel = styled.label`
  text-align: left;
`;

const NotesInput = styled.textarea`
  width: 100%;
  height: 100px;
  margin-bottom: 10px;
`;

const CheckoutButton = styled.input`

`;

const StyledInput = styled(NumericInput)`
  width: 82px;
  border: none !important;
  font-size: 16px !important;
  color: #938985 !important;
`;

const BottomSection = styled.div`
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  padding: 0px 60px 18px;
  text-align: center;
  background: white;
  border-top: 1px solid #E3E1E0;
  h6 {
    margin: 18px 0 0;
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0px;
  background: #FDFBF9;
  z-index: 900;
  width: 100%;
  height: 100%;
  transition: opacity 500ms ease;
  ${props => props['data-open'] ? `
    opacity: 0.8;
    pointer-events: auto;
  ` : `
    opacity: 0;
    pointer-events: none;
  `});
`;

const SubHead = styled.h6`
  ${props => props['data-gift'] ? `
    color: #C67732;
  ` : ``});
`;

const handleFetchStatus = res => {
  if (res.status < 200 || res.status >= 300) {
    throw new Error(res.statusText);
  }
  return res;
};

const toMoney = val => `\$${(val / 100).toFixed(2)}`;

class CartDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      cartPage: false
    }

    this.handleCartButtonClick = this.handleCartButtonClick.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
  }

  componentDidMount() {
    this.btn = document.querySelector('.js-cart-btn');
    if (this.btn) {
      this.btn.addEventListener(`click`, this.handleCartButtonClick)
    }
    else {
      console.log('Cart button not found')
    }

    const addForm = Array.from(document.querySelectorAll('.product-form'));
    if (addForm) {
      addForm.map((form) => {
        this.addProductAddForm(form);
      })
    }

    // handle when ajax cart forms from quickview are added
    const _self = this;
    document.addEventListener('quickviewloaded', function(e) {
      const forms = Array.from(e.target.querySelectorAll('.product-form'));
      if (forms) {
        forms.map((form) => {
          _self.addProductAddForm(form, e.quickview);
        })
      }
    });

    this.getCart(false);
  }

  addProductAddForm = (form, quickview) => {
    form.addEventListener(`submit`, e => {
      e.preventDefault();
      const formData = [...form.querySelectorAll('input,select')];
      const formProperties = formData.filter(i => i.name.includes("properties"));
      const filteredFormProperties =  formProperties.length > 0 ? formProperties.map(i =>
        i.name && ({ [i.name.replace('properties[', '').replace(']', '')]: i.value })
      ).reduce((acc, val) => (
        Object.assign({},
          acc,
          val
        )
      )) : {};

      const serial = formData.filter(i => !i.name.includes("properties")).map(i =>
        i.name && ({[i.name]: i.value})
      ).reduce((acc, val) => (
        Object.assign({},
          acc,
          val
        )
      ), { properties: filteredFormProperties, quantity: 1 });

      var lastReq = fetch('/cart/add.js', {
        credentials: 'same-origin',
        method: 'POST',
        body: JSON.stringify(serial),
        headers: {
          'content-type': 'application/json'
        },
      });

      // add necessary mailers for recurring items
      if (serial.properties.frequency_num &&
        !this.mailerFor(this.state.cart, serial.properties.frequency_num, serial.properties.frequency_type)) {

        lastReq = lastReq.then(handleFetchStatus)
          .then(() => {
            return fetch('/cart/add.js', {
              credentials: 'same-origin',
              method: 'POST',
              body: JSON.stringify({
                id: this.props.mailer.variants[0].id,
                quantity: 1,
                properties: {
                  frequency_num: serial.properties.frequency_num,
                  frequency_type: serial.properties.frequency_type,
                  frequency_type_text: serial.properties.frequency_type_text,
                  discounted_price: 0,
                  group_id: 65885,
                  _ro_discount_percentage: 0,
                  _ro_unformatted_price: "0"
                }
              }),
              headers: { 'content-type': 'application/json' }
            });
          });
      }

      lastReq.then(handleFetchStatus)
        .then()
        .then(() => {
          if (quickview) {
            quickview.close();
          }
          this.toggleOpen(true);
        })
    })
  }

  mailerFor = (cart, freqNum, freqType, returnIndex) => {
    const _this = this;
    var f = _.find;
    if (returnIndex) { f = _.findIndex; }
    return f(cart.items, function(i) {
      return i.product_id == _this.props.mailer.id &&
        parseInt(i.properties.frequency_num) == parseInt(freqNum) &&
        parseInt(i.properties.frequency_type) == parseInt(freqType);
    });
  }

  checkUrl() {
    if (!this.state.cartPage) {
      return window.location.pathname == '/cart';
    }
    return false;
  }

  handleCartButtonClick(e) {
    e.preventDefault();
    this.toggleOpen(true);
  }

  handleCloseClick(e) {
    e.preventDefault();
    this.toggleOpen(false);
  }

  toggleOpen(isOpen) {
    if (isOpen) {
      this.getCart(isOpen);
    } else {
      this.setState({ isOpen });
    }
  }

  getCart(isOpen) {
    fetch('/cart.js',
      {
        credentials: 'same-origin'
      }
    )
      .then(handleFetchStatus)
      .then(res => res.json())
      .then(cart => {
        let motivator_ajax = (cart) => {
          this.updateGlobalCount(cart.item_count);
          if (this.checkUrl()) {
            this.setState({
              cart,
              isOpen: true,
              cartPage: true
            });
          } else {
            this.setState({
              cart,
              isOpen
            });
          }
          if(typeof trigger_messages == 'function'){
            trigger_messages();
          }
        }
        if(typeof updateMotivator == 'function') {
          updateMotivator(cart, this.getTotal(cart), motivator_ajax);
        }
        else {
          motivator_ajax(cart);
        }
      })
  }

  updateGlobalCount(count) {
    this.btn.innerHTML = `Bag (${count})`;
  }

  handleInputChange = (newVal, valStr, comp, item, line) => {
    // cannot adjust mailer quantities
    if (item.product_id == this.props.mailer.id) {
      return false;
    }

    var lastReq = fetch('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify({
        line: line,
        quantity: newVal
      }),
      headers: {
        'content-type': 'application/json'
      },
      credentials: 'same-origin'
    });

    if (newVal == 0 && item.properties && item.properties.frequency_num) {
      const mailer = this.mailerFor(this.state.cart, item.properties.frequency_num, item.properties.frequency_type);
      var _this = this;
      if (mailer &&
        _.filter(this.state.cart.items, (i) => {
          return i.product_id != _this.props.mailer.id &&
            parseInt(i.properties.frequency_num) == parseInt(item.properties.frequency_num) &&
            parseInt(i.properties.frequency_type) == parseInt(item.properties.frequency_type)
        }).length == 1) {

        lastReq = lastReq.then(handleFetchStatus)
          .then((res) => res.json())
          .then((cart) => {
            const mailerLine = this.mailerFor(cart, item.properties.frequency_num, item.properties.frequency_type, true) + 1;
            return fetch('/cart/change.js', {
              method: 'POST',
              body: JSON.stringify({
                line: mailerLine,
                quantity: 0
              }),
              headers: { 'content-type': 'application/json' },
              credentials: 'same-origin'
            });
          });
      }
    }

    lastReq
      .then(handleFetchStatus)
      .then(res => res.json())
      .then(cart => {
        let motivator_ajax = (cart) => {
          this.updateGlobalCount(cart.item_count);
          this.setState({
            cart
          });
          if(typeof trigger_messages == 'function'){
            trigger_messages();
          }
        }
        if(typeof updateMotivator == 'function') {
          updateMotivator(cart, this.getTotal(cart),  motivator_ajax);
        }
        else {
          motivator_ajax(cart);
        }
      })

  }

  updateImageUrl( url ) {
    return url != null ?
                  url.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') :
                  "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
  }

  getTimePeriod( properties ) {
    return `Every ${properties.frequency_num
} ${properties.frequency_type_text}`;
  }

  getPrice(item) {
    if ( item.properties ) {
      return (
        parseInt(_.get(item, 'properties._ro_unformatted_price')) *
        parseInt(_.get(item, 'quantity'))
      );
    }
    return _.get(item, 'line_price');
  }

  getTotal(cart) {
    let items = _.get(cart, 'items');
    if ( items.length > 0 ) {
      return items.map(i => parseInt(this.getPrice(i))).reduce((a, b) => a + b);
    }
    return _.get(cart, 'total_price');
  }

  renderCartContent(cart, isOpen) {
    if (_.isEmpty(cart)) {
      return (
        <div>
          Loading...
        </div>
      )
    }

    const items = _.get(cart, 'items');
    return (
      <InnerContainer>
        {items.length > 0 ? (
            items.map((i, index) => (
              <Item
                data-open={isOpen}
                data-index={index}
                key={i.key}
              >
                <Image src={this.updateImageUrl(_.get(i, 'image'))} alt={_.get(i, 'title')} />
                <ItemContent>
                  <p>{_.get(i, 'title')}</p>
                  {i.properties ? <SubHead>{this.getTimePeriod(i.properties)}</SubHead> : i.product_type === 'MOTIVATOR_HIDDEN_PRODUCT' ? <SubHead data-gift={true}>Free gift</SubHead> : <SubHead>One time purchase</SubHead>}
                  {i.product_type !== 'MOTIVATOR_HIDDEN_PRODUCT' && parseInt(i.product_id) != parseInt(this.props.mailer.id) ?
                    <StyledInput
                      min={0}
                      mobile={true}
                      value={_.get(i, 'quantity')}
                      onChange={(newVal, valStr, comp) => this.handleInputChange(newVal, valStr, comp, i, index + 1)}
                    /> : ''
                  }
                </ItemContent>
                <Price>
                  <h6>{toMoney(this.getPrice(i))}</h6>
                </Price>
              </Item>
            ))
        ) : (
          <div>
          </div>
        )}
        <BottomSection>
          <form
            action="/cart"
            method="post"
            noValidate
          >
            <NotesLabel>Order Notes:</NotesLabel>
            <NotesInput name="note" defaultValue={_.get(cart, 'note')} />
            <CheckoutButton
              className="button full-width"
              type="submit"
              name="checkout"
              value={`${toMoney(this.getTotal(cart))} — Checkout`}
            />
          </form>
          <h6>Shipping & taxes calculated at checkout</h6>
        </BottomSection>
      </InnerContainer>
    );
  }

  render() {
    const { isOpen, cart } = this.state;
    const items = _.get(cart, 'items') || [];
    return (
      <React.Fragment>
        <Overlay
          className="overlay-close-cursor"
          data-open={isOpen}
          onClick={this.handleCloseClick}
        />
        <Container data-open={isOpen}>
          {this.renderCartContent(cart, isOpen)}
          <MobileCloseButton
            className="close-btn-background"
            onClick={this.handleCloseClick}
          />
          <CloseButton onClick={this.handleCloseClick}>
            bag (<Count>{_.get(cart, 'item_count')}</Count>)
          </CloseButton>
        </Container>
      </React.Fragment>
    );
  }
}

export default CartDrawer;
